"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAffiliatesContext = void 0;
var React = require("react");
var affiliates_context_1 = require("./context/affiliates.context");
Object.defineProperty(exports, "useAffiliatesContext", {
  enumerable: true,
  get: function () {
    return affiliates_context_1.useAffiliatesContext;
  }
});
function AffiliatesContextPlugin() {
  return {
    name: 'eg-affiliates-context',
    onBrowserHydrateRenderContext: function (context, next) {
      var hydratedState = context.hydratedState,
        setAppData = context.setAppData;
      var affiliatesContext = hydratedState.affiliatesContext;
      setAppData({
        affiliatesContext: affiliatesContext
      });
      return next(context);
    },
    onBrowserWrapRootElement: function (context, next) {
      var getAppData = context.getAppData,
        setRootElement = context.setRootElement;
      setRootElement(function (RootElement) {
        return function (props) {
          return React.createElement(affiliates_context_1.AffiliatesContextProvider, {
            affiliatesContext: getAppData().affiliatesContext
          }, React.createElement(RootElement, null, props.children));
        };
      });
      return next(context);
    }
  };
}
exports.default = AffiliatesContextPlugin;